


























































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import Validations from '@/lib/Validations'
import {State, Action} from 'vuex-class'
import Utils from '@/utils'
import ChangeLangDialog from '@/views/ChangeLangDialog.vue'

import {extend} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import {FlowInputField as Field, FlowInputStep} from '@/lib/kepler/interfaces'
import PaymentMethods from '@/components/wallet/PaymentMethods.vue'
import PaymentMethodsWithValidation from '@/components/fields/PaymentMethodsWithValidation.vue'
import CheckboxFieldWithValidation from '@/components/fields/CheckboxFieldWithValidation.vue'
import FlowPlans from '@/components/flow/flowFields/Plans.vue'
import FlowLogin from '@/components/flow/flowFields/Login.vue'
import RadioButtons from '@/components/flow/flowFields/RadioButtons.vue'

for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
  })
}

@Component({
  components: {
    RadioButtons,
    FlowLogin,
    FlowPlans,
    CheckboxFieldWithValidation,
    PaymentMethodsWithValidation,
    PaymentMethods,
    AutoCompleteFieldWithValidation: Utils.loadComponent('fields/AutoCompleteFieldWithValidation'),
    RegistrationDocumentsComponent: Utils.loadComponent('registration/RegistrationDocumentsComponent'),
    RegistrationPhoneVerification: Utils.loadComponent('registration/RegistrationPhoneVerification'),
    RegistrationSummaryComponent: Utils.loadComponent('registration/RegistrationSummaryComponent'),
    RegistrationAddressComponent: Utils.loadComponent('registration/RegistrationAddressComponent'),
    CountriesFieldWithValidation: Utils.loadComponent('fields/CountriesFieldWithValidation'),
    SelectFieldWithValidation: Utils.loadComponent('fields/SelectFieldWithValidation'),
    PhoneFieldWithValidation: Utils.loadComponent('fields/PhoneFieldWithValidation'),
    DateFieldWithValidation: Utils.loadComponent('fields/DateFieldWithValidation'),
    TextFieldWithValidation: Utils.loadComponent('fields/TextFieldWithValidation'),
    InputDatePicker: Utils.loadComponent('proxy/Inputs/InputDatePicker'),
    PhoneWithPrefix: Utils.loadComponent('PhoneWithPrefix'),
    TextField: Utils.loadComponent('proxy/Inputs/TextField'),
    CheckBox: Utils.loadComponent('proxy/Inputs/CheckBox'),
    Summary: Utils.loadComponent('flow/flowFields/Summary'),
    Picture: Utils.loadComponent('registration/RegistrationImageComponent'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Button: Utils.loadComponent('Button'),
    Selfie: Utils.loadComponent('registration/RegistrationSelfieComponent'),
    Tos: Utils.loadComponent('registration/RegistrationFieldTos'),
    ChangeLangDialog,
  },
  name: 'FlowField',
})

export default class FlowField extends Vue {
  @State('flowOutputs') public flowOutputs!: { [k: string]: any }
  @Action('openDialog') public openDialog: any
  @Prop() public step?: FlowInputStep
  @Prop() public field!: Field
  @Prop() public disabled?: boolean

  public rules: any = Validations.rules
  public currentRules: any[] = []
  public required: boolean = false
  public valid: boolean = false
  public loading: boolean = false

  public get fieldID() {
    const context = this.step?.context
    const fieldArr = this.field.id?.split('.')
    if (fieldArr) {
      if (context) {
        fieldArr.unshift(context)
      }
      const prop = Utils.getProp(this.flowOutputs, fieldArr)
      return prop || this.field.value || null
    }
    return null
  }

  public set fieldID(value) {
    const context = this.step?.context
    const fieldArr = this.field.id.split('.')
    if (context) {
      fieldArr.unshift(context)
    }

    Utils.setProp(this.flowOutputs, fieldArr, value)
  }

  public parseRules() {
    const arr = []
    const val = this.field.validation

    if (val) {
      if (typeof val === 'string') {
        const v = val.split('|')
        if (v.includes('required')) {
          this.required = true
          arr.push(this.rules.required)
        }
        if (v.includes('email')) {
          arr.push(this.rules.email)
        }
      } else if (typeof val === 'object') {
        if (val.hasOwnProperty('required')) {
          this.required = true
          arr.push(this.rules.required)
        }
        if (val.hasOwnProperty('email')) {
          arr.push(this.rules.email)
        }
      }
    }

    return arr
  }

  protected created() {
    this.currentRules = this.parseRules()
    if (this.field.type === 'hidden') {
      const value = this.field.value
      const defaultValue = this.field.validation?.split('|').find((s: string) => s.includes('default'))?.split(':')[1]
      if (value) {
        this.fieldID = value
      } else if (defaultValue) {
        this.fieldID = defaultValue
      }
    }
    if (!this.fieldID && this.field.value) {
      this.$set(this, 'fieldID', this.field.value)
      this.fieldID = this.field.value
    }
  }

}
